<template>
    <router-link :to="{ name: 'used-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a"
        class="search-results-vehicle" @click.stop.native="'Used Vehicles - Results', 'Clicked', 'Card'" :id="elementId">
        <template v-if="pictureCount == 0">
            <div class="search-results-vehicle__bg-img"
                style="background-image: url(/images/used/image-coming-soon@2x.jpg)"></div>
            <picture>
                <source media="(min-width: 992px)"
                    :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                <source srcset="/images/used/image-coming-soon.webp, /images/used/image-coming-soon@2x.webp 2x"
                    type="image/webp" />
                <img class="search-results-vehicle__img"
                    srcset="/images/used/image-coming-soon.jpg, /images/used/image-coming-soon@2x.jpg 2x"
                    itemprop="thumbnail" :alt="'Used ' + vehicle.vehicle_title + ' Photo Coming Soon'" />
            </picture>
            <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                <img src="/images/used/reserved-logo.png"
                    srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x"
                    alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                <div class="vehicle__reserved-text">This car has now been <span
                        class="vehicle__reserved-bold">reserved</span></div>
            </div>
        </template>
        <template v-else-if="pictureCount == 1">
            <div class="search-results-vehicle__bg-img" :style="{ 'background-image': 'url(' + currentGalleryImage + ')' }">
            </div>
            <picture>
                <source media="(min-width: 992px)"
                    :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                <img class="search-results-vehicle__img" :srcset="vehicle.used_vehicles_internal_images[0].thumbnail_path"
                    alt="" />
            </picture>
            <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                <img src="/images/used/reserved-logo.png"
                    srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x"
                    alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                <div class="vehicle__reserved-text">This car has now been <span
                        class="vehicle__reserved-bold">reserved</span></div>
            </div>
        </template>
        <template v-else>
            <div class="search-results-vehicle__img-container">
                <img src="/images/used/prev.svg" @click.stop.prevent="previousImage"
                    class="search-results-vehicle__arrow search-results-vehicle__arrow--prev"
                    :class="{'search-results-vehicle__arrow--disabled': !hasPreviousImage}" alt="Previous Image" />
                <img src="/images/used/next.svg" @click.stop.prevent="nextImage"
                    class="search-results-vehicle__arrow search-results-vehicle__arrow--next"
                    :class="{'search-results-vehicle__arrow--disabled': !hasNextImage}" alt="Next Image" />
                <div class="search-results-vehicle__bg-img"
                    :style="{ 'background-image': 'url(' + currentGalleryImage + ')' }"></div>
                <picture>
                    <source media="(min-width: 992px)"
                        :srcset="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                    <img class="search-results-vehicle__img" :srcset="currentGalleryImage" alt="" />
                </picture>
                <div class="vehicle__reserved-bg" v-if="vehicle.reserved != null">
                    <img src="/images/used/reserved-logo.png"
                        srcset="/images/used/reserved-logo.png, /images/used/reserved-logo@2x.png 2x"
                        alt="This vehicle has now been reserved" class="img-responsive vehicle__reserved-img" />
                    <div class="vehicle__reserved-text">This car has now been <span
                            class="vehicle__reserved-bold">reserved</span></div>
                </div>
            </div>
        </template>

        <div class="search-results-vehicle__spacer search-results-vehicle__spacer--offer">
            <div v-if="depositContribution !== false" class="search-results-vehicle__offer-tag search-results-vehicle__offer-tag--depcon">
                £{{ depositContribution }} Finance Deposit Contribution
                <span v-if="onlyInSeptember" style="display: block;font-size: 0.8em;">Only Available During September</span>
            </div>
            <picture v-if="hasHomeChargerOffer">
                <source type="image/webp" srcset="/images/events/2025/home-charger/results.webp">
                <img class="img-responsive" srcset="/images/events/2025/home-charger/results.jpg" style="width:100%" alt="">
            </picture>
        </div>
        <div class="search-results-vehicle__title-row">
            <div class="search-results-vehicle__title-area"
                @click.stop.native="gaTag('Used Vehicles - Result', 'Clicked', 'Title')">
                <h4 class="search-results-vehicle__title">{{ vehicle.manufacturer }} {{ vehicle.model }}</h4>
                <h5 class="search-results-vehicle__subtitle">{{ vehicle.version }}</h5>
            </div>
            <div class="search-results-vehicle__save-vehicle">
                <input type="checkbox" value="" class="save-to-compare" :id="'compare-' + vehicle.id" name="save-to-compare"
                    v-model="inCompareList" />
                <label :for="'compare-' + vehicle.id" class="search-results-vehicle__save-vehicle-button">
                    <svg :class="{ 'search-results-vehicle__save-vehicle-icon': true, 'search-results-vehicle__save-vehicle-icon--active': inCompareList }"
                        width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z" />
                    </svg>
                </label>
            </div>
        </div>
        <div class="search-results-vehicle__card-inner">
            <hr class="search-results-vehicle__hr" />

            <div class="search-results-vehicle__prices-container">
                <div class="search-results-vehicle__prices">
                    <router-link :to="{ name: 'used-details', params: { id: vehicle.id, slug: vehicle.slug } }" tag="a"
                        class="search-results-vehicle__price"
                        @click.stop.native="gaTag('Used Vehicles - Results', 'Clicked', 'Cash price')">
                        Cash Price
                        <span class="search-results-vehicle__price-label">&pound;{{ vehicle.price_formatted }}</span>
                        <span class="pricing-area__vat-price" v-if="vehicle.vat_type == 'vat'">+VAT</span>
                    </router-link>
                    <div class="search-results-vehicle__price" v-if="finance == 'loading'">
                        Per Month
                        <span class="search-results-vehicle__per-month-error">
                            <div class="loading"><img src="/images/shared/Robins-And-Day-Loader.svg"
                                    alt="Loading Results" /></div>
                        </span>
                    </div>
                    <div class="search-results-vehicle__price" v-else-if="finance == 'out-of-range' || !finance">
                        Per Month
                        <span class="search-results-vehicle__per-month-error">
                            Ask about finance
                        </span>
                    </div>
                    <router-link v-else :to="financeLink" tag="a" class="search-results-vehicle__price"
                        @click.stop.native="gaTag('Used Vehicles - Results', 'Clicked', 'Monthly price')">
                        Per Month
                        <span class="search-results-vehicle__per-month-label">&pound;{{ monthlyPayment }}</span>
                    </router-link>
                </div>
                <auto-trader-value-rating class="search-results-vehicle__at-rating-container" :rating="vehicle.value_rating"
                    :classes="{ 'at-lg-value-img': true, 'hidden-xs': true }"></auto-trader-value-rating>
            </div>

            <hr class="search-results-vehicle__hr" />

            <div v-if="hasKeySpec" class="search-results-vehicle__spec">
                <div v-for="(specItem, index) in keySpec" :key="index" class="search-results-vehicle__spec-item"
                    v-html="specItem"></div>
            </div>

            <div class="search-results-vehicle__spacer search-results-vehicle__spacer--warranty">
                <div v-if="hasWarranty && formattedWarrantyDuration"
                    class="search-results-vehicle__warranty"
                    :class="{'search-results-vehicle__warranty--ds': warrantyProvider == 'DS', 'search-results-vehicle__warranty--alfa': warrantyProvider == 'Alfa Romeo'}"
                >
                    <img
                        src="/images/used/black-tick.svg"
                        alt=""
                        class="search-results-vehicle__warranty-icon"
                    />
                    <span class="search-results-vehicle__warranty-copy">
                        {{ formattedWarrantyProvider }}
                    </span>
                </div>

                <div v-if="hasWarranty && formattedWarrantyDuration"
                    class="search-results-vehicle__warranty search-results-vehicle__warranty--manufacturer"
                >
                    <img
                        src="/images/used/blue-tick.svg"
                        alt=""
                        class="search-results-vehicle__warranty-icon"
                    />
                    <span class="search-results-vehicle__warranty-copy">
                        Warranty:&nbsp; {{ formattedWarrantyDuration }}
                    </span>
                </div>

                <div v-if="formattedBatteryWarranty"
                    class="search-results-vehicle__warranty search-results-vehicle__warranty--battery"
                >
                    <img
                        src="/images/used/green-tick.svg"
                        alt=""
                        class="search-results-vehicle__warranty-icon"
                    />
                    <span class="search-results-vehicle__warranty-copy">
                        Battery Warranty:&nbsp; {{ formattedBatteryWarranty }}
                    </span>
                </div>
            </div>

            <div class="search-results-vehicle__dealer" v-if="vehicle.l_name">
                <img src="/images/used/used-pin.svg" alt="Map pin" class="search-results-vehicle__pin" />
                {{ vehicle.l_name }}
            </div>
        </div>
    </router-link>
</template>

<script>
import FinanceProducts from "../api/finance/FinanceProducts";
import numberFormat from "../api/NumberFormat";
import { financeKeys } from "../../modules/json/financeKeys";
import AutoTraderValueRating from "../components/AutoTraderValueRating";
import FormatWarranty from "../api/FormatWarranty";

export default {
    components: {
        AutoTraderValueRating,
    },
    props: {
        vehicle: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            imageIndex: 0,
            financeProducts: new FinanceProducts(),
            displayOffer:false
        };
    },
    watch: {
        "vehicle.finance": function (newVal, oldVal) {
            this.init();
        },
    },
    methods: {
        init() {
            if (this.vehicle.finance && this.vehicle.finance.FinanceProductResults) {
                this.financeProducts.setVehicle(this.vehicle);
                this.financeProducts.setProducts(this.vehicle.finance.FinanceProductResults);
            }
            this.$nextTick(function() {
                this.$emit('card-updated');
            })
        },
        showRepresentativeExample() {
            this.$store.commit("RepresentativeExample/setPaymentSearch", this.paymentSearch);
            this.$store.commit("RepresentativeExample/setQuote", this.finance);
            this.$store.commit("RepresentativeExample/setVehicle", this.vehicle);
            this.$store.commit("RepresentativeExample/setShowModal", true);
        },
        previousImage() {
            if (!this.hasPreviousImage) {
                return;
            }
            this.imageIndex--;
        },
        nextImage() {
            if (!this.hasNextImage) {
                return;
            }
            this.imageIndex++;
        }
    },
    computed: {

        hasNextImage() {
            if (this.pictureCount <= 1) {
                return false;
            }
            return ((this.imageIndex + 1) < this.pictureCount);
        },
        hasPreviousImage() {
            if (this.pictureCount <= 1) {
                return false;
            }
            return (this.imageIndex > 0);
        },
        currentGalleryImage() {
            if (this.pictureCount > 0) {
                return this.vehicle.used_vehicles_internal_images[this.imageIndex].thumbnail_path;
            }

            return "/images/used/image-coming-soon@2x.jpg";
        },

        pictureCount() {
            if (this.vehicle.used_vehicles_internal_images) {
                return this.vehicle.used_vehicles_internal_images.length;
            }
            return 0;
        },

        inCompareList: {
            get() {
                return this.$store.state.Layout.compare.used.indexOf(String(this.vehicle.id)) == -1 ? false : true;
            },
            set(value) {
                this.gaTag('Used Vehicles - Result', 'Clicked', 'Save/Compare - ' + ((this.inCompareList === true) ? 'Removed' : 'Added'));
                this.$store.dispatch("Layout/saveVehicle", {
                    type: "used",
                    id: this.vehicle.id,
                    add: !this.inCompareList,
                });
            },
        },
        paymentSearch() {
            return this.$store.state.UsedSearchOptions.userOptions.paymentSearch;
        },
        elementId() {
            return "vehicle-result-" + this.vehicle.id;
        },
        hasKeySpec() {
            return this.keySpec.length > 0;
        },
        keySpec() {
            const keySpec = [];
            keySpec.push(numberFormat(this.vehicle.mileage, 0) + ' miles');
            if (this.vehicle.vehicle_reg_letter) {
                keySpec.push(this.vehicle.vehicle_reg_letter + ' Plate');
            }
            if (this.vehicle.fuel_type != '') {
                keySpec.push(this.vehicle.fuel_type);
            }
            keySpec.push(this.shortTransmission);
            if (this.vehicle.vehicle_mpg > 0) {
                keySpec.push(numberFormat(this.vehicle.vehicle_mpg, 2) + ' mpg');
            }
            return keySpec;
        },
        shortTransmission() {
            const transmission = String(this.vehicle.transmission).toLowerCase();
            if (transmission == 'automatic') {
                return 'Auto';
            }
            if (transmission == 'manual') {
                return 'Manual';
            }
            return this.vehicle.transmission;
        },
        finance() {
            if (!this.vehicle.finance || this.vehicle.finance == "loading") {
                return "loading";
            }

            // const regularPaymentKeyToUse = (this.paymentSearch == 1) ? 'TotalRegularPayment' : 'AllInclusiveRegularPayment';
            const preferredKey = (this.vehicle.brand && this.vehicle.brand == 'vauxhall') ? 'VAUXHALL_PCP_ONLY' : "PSA_PCP_ONLY";
            const manufacturerPcp = this.financeProducts.getQuoteOfKey(financeKeys[preferredKey]);
            if (manufacturerPcp) {
                return manufacturerPcp;
            }
            const dsgPcp = this.financeProducts.getQuoteOfKey(financeKeys.DSG_PCP_ONLY);
            if (dsgPcp) {
                return dsgPcp;
            }
            const hp = this.financeProducts.getQuoteOfKey(financeKeys.HP);
            if (hp) {
                return hp;
            }
            return false;
        },
        financeLink() {
            if (!this.finance || this.finance == "loading") {
                return { name: "used-details", params: { id: this.vehicle.id, slug: this.vehicle.slug } };
            }
            const deposit = this.paymentSearch == 1 ? this.finance.Quote.Deposit.Cash : this.finance.Quote.CashDeposit;
            const term = this.finance.Quote.Term;
            const mileage = this.finance.Quote.AnnualMileage;
            const key = this.finance.Key;

            return {
                name: "used-details",
                params: { id: this.vehicle.id, slug: this.vehicle.slug },
                query: {
                    deposit: deposit,
                    term: term,
                    mileage: mileage,
                    key: key,
                },
            };
        },
        monthlyPayment() {
            if (!this.finance || this.finance == "loading") {
                return "";
            }
            if (this.paymentSearch == 1) {
                return numberFormat(this.finance.Quote.TotalRegularPayment, 0);
            }
            return numberFormat(this.finance.Quote.AllInclusiveRegularPayment, 0);
        },
        // terms() {
        //     if (!this.finance || this.finance == "loading") {
        //         return "";
        //     }
        //     if (typeof this.finance.Product == "undefined" || typeof this.finance.Product.Lender == "undefined") {
        //         return "";
        //     }
        //     if (this.finance.Product.Lender == "PSA Finance") {
        //         return "Stellantis Financial Services UK Limited";
        //     }
        //     if (this.finance.Product.Lender == "Peugeot Financial Services") {
        //         return "Stellantis Financial Services UK Limited";
        //     }
        //     if (this.finance.Product.Lender == "Citroen Financial Services") {
        //         return "Stellantis Financial Services UK Limited";
        //     }
        //     if (this.finance.Product.Lender == "Black Horse") {
        //         return "Black Horse";
        //     }
        //     if (this.finance.Product.Lender == "DSG Finance Services") {
        //         return "DSG Finance Services";
        //     }
        //     if (this.finance.Product.Lender == "Vauxhall Finance") {
        //         return "Vauxhall Finance";
        //     }
        //     return "";
        // },
        depositContribution() {
            if (this.finance.hasOwnProperty("Quote")) {
                return this.finance.Quote.DepositContribution > 0 ? this.finance.Quote.DepositContribution : false;
            }
            return false;
        },

        hasWarranty() {
            if (this.vehicle.is_spoticar == 1) {
                return true;
            }

            if (this.vehicle.short_warranty != '6MONTH') {
                return true;
            }

            return false;
        },

        warrantyProvider() {
            if (!this.hasWarranty) return '';

            if (this.vehicle.short_warranty == 'DSCERTIFIED24' || this.vehicle.short_warranty == 'DSCERTIFIED12') {
                return 'DS';
            }

            if (this.vehicle.short_warranty == 'ALFACERTIFIED24' || this.vehicle.short_warranty == 'ALFACERTIFIED12') {
                return 'Alfa Romeo';
            }

            return 'SPOTICAR';
        },
        formattedWarrantyDuration() {
            return FormatWarranty(Math.max(this.vehicle.manufacturer_warranty_months, this.vehicle.warranty_months), '');
        },
        formattedWarrantyProvider() {
            if (!this.warrantyProvider) return '';

            const suffix = {
                SPOTICAR: 'Approved',
                DS: 'Certified',
                'Alfa Romeo': 'Certified',
            }[this.warrantyProvider] || 'Manufacturer Approved';

            return `${this.warrantyProvider} ${suffix}`;
        },
        formattedBatteryWarranty() {
            return FormatWarranty(this.vehicle.battery_warranty_months, '');
        },
        extraDataArray() {
            if (this.vehicle.extra_data.length == 0) {
                return [];
            }

            return this.vehicle.extra_data.split(' ');
        },
        hasHomeChargerOffer() {
            if (!this.vehicle) {
                return false;
            }
            if (this.extraDataArray.length == 0) {
                return false;
            }
            return this.extraDataArray.includes('wallbox-offer');
        },
        onlyInSeptember() {
            if (!this.vehicle) {
                return false;
            }
            if (this.extraDataArray.length == 0) {
                return false;
            }
            return this.extraDataArray.includes('500-deposit-contribution-september-2025');
        },
    },
    mounted() {
        this.init();
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedVehicleResult.vue